module.exports = __webpack_public_path__ + "static/img/img_01f.15cc099.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/img_01f.png
// module id = EbkH
// module chunks = 17